import { GridLegacy } from "@mui/material";
import React from "react";
import { CheckCircle, Warning } from "@mui/icons-material";
import { _get } from "../../../../http";

function JamezzPaymentsMethods(props) {
  const togglePaymentMethod = (method) => {
    const url = "core/payments/toggleMethod?vid=" + props.paymentSettings.vestiging_id + "&id=" + method;
    _get(url).then((result) => {
      props.reloadDataFromServer();
    });
  };

  return (
    <div style={{ paddingLeft: "20px" }}>
      {props.paymentSettings && props.paymentSettings.settings
        ? Object.keys(props.paymentSettings.settings).map((name) => {
            return (
              <GridLegacy container spacing={1} style={{ marginBottom: "10px" }}>
                <GridLegacy md={4} xs={12}>
                  <span
                    onClick={() => {
                      togglePaymentMethod(props.paymentSettings.settings[name].id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {props.paymentSettings.settings[name].active ? (
                      <CheckCircle
                        style={{ color: "green", width: "18px", position: "relative", top: "7px", marginRight: "10px" }}
                      />
                    ) : (
                      <Warning
                        style={{
                          color: "#fc5203",
                          width: "18px",
                          position: "relative",
                          top: "7px",
                          marginRight: "10px",
                        }}
                      />
                    )}
                    <img src={props.paymentSettings.settings[name].image} style={{ marginRight: "10px" }} />
                    <b>{props.paymentSettings.settings[name].name}</b>
                  </span>
                </GridLegacy>
                <GridLegacy align={"left"} md={3} style={{ marginTop: "5px" }} xs={12}>
                  {props.paymentSettings.settings[name].issuers !== undefined &&
                  props.paymentSettings.settings[name].issuers
                    ? Object.keys(props.paymentSettings.settings[name].issuers).map((iname) => {
                        return (
                          <GridLegacy md={12} xs={12}>
                            <img
                              src={props.paymentSettings.settings[name].issuers[iname].image}
                              style={{ marginRight: "10px" }}
                            />
                            <b>{props.paymentSettings.settings[name].issuers[iname].name}</b>
                          </GridLegacy>
                        );
                      })
                    : null}
                </GridLegacy>
              </GridLegacy>
            );
          })
        : null}
    </div>
  );
}

export default JamezzPaymentsMethods;
